/* ===========================================================
   환경 설정 — .env의 REACT_APP_ENV("dev" | "prod") 하나로
   환경별 엔드포인트/리소스를 분기한다.
   - 미지정 시 dev
   - .env에 REACT_APP_GRAPHQL_ENDPOINT / REACT_APP_SERVER_ENDPOINT를
     직접 지정하면 그 값이 우선한다 (로컬 서버 테스트용 오버라이드)
   =========================================================== */
export const ENV = process.env.REACT_APP_ENV || "dev";

const ENDPOINTS = {
  prod: {
    graphql: "https://api1-kr.kidsda.com/graphql",
    server: "https://api1-kr.kidsda.com",
  },
  dev: {
    graphql: "https://kd-dev.wegolab.net/graphql",
    server: "https://kd-dev.wegolab.net",
  },
};

const picked = ENDPOINTS[ENV] || ENDPOINTS.dev;

export const GRAPHQL_ENDPOINT =
  process.env.REACT_APP_GRAPHQL_ENDPOINT || picked.graphql;
export const SERVER_ENDPOINT =
  process.env.REACT_APP_SERVER_ENDPOINT || picked.server;
